import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "./styles";

type ButtonProperties = {
  title: string | undefined;
  icon: any;
  onOpen: () => void;
  type?: string;
};

export const Button: React.FC<ButtonProperties> = ({ title, icon, onOpen }) => (
  <Container onClick={onOpen}>
    <FontAwesomeIcon icon={icon} />
    <span>{title}</span>
  </Container>
);
